import styles from "./NewBill.module.css";
import { useState, useContext } from "react";
import Modal from "../../components/Modal/Modal";
import billService from "../../services/bill.service";
import uploadService from "../../services/upload.service";
import { AuthContext } from "../../contexts/auth.context";
import ScreenHeader from "../../components/ScreenHeader/ScreenHeader";

function NewBill() {
  const [description, setDescritcion] = useState("");
  const [file, setFile] = useState(undefined);
  const [modalVisible, setModalVisible] = useState(false);

  const { user, setIsLoading } = useContext(AuthContext);

  const handleDescripcionChange = (e) => {
    setDescritcion(e.target.value);
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const formData = new FormData();
    formData.append("fileData", file);

    const cloudinayPath = await uploadService.uploadfile(formData);

    const bill = {
      description,
      user: user.email,
      fileName: cloudinayPath.data.cloudinary_url,
    };

    billService
      .new(bill)
      .then(() => {
        setIsLoading(false);
        setModalVisible(true);
        setDescritcion("");
        setFile(undefined);
      })
      .catch((error) => {
        console.error("Error al guardar la factura:", error);
      });
  };

  return (
    <>
      <Modal
        isOpen={modalVisible}
        onClose={() => setModalVisible(false)}
        type="success"
      >
        <p>Factura subida con éxito.</p>
      </Modal>

      <div className={styles.container}>
        <ScreenHeader title="Nueva Factura" />

        <form className={styles.form} onSubmit={handleSubmit}>
          <div className={styles["form-group"]}>
            <label htmlFor="description">Descripción:</label>
            <textarea
              className={styles.textarea}
              id="description"
              name="description"
              rows="4"
              required
              value={description}
              onChange={handleDescripcionChange}
            ></textarea>
          </div>
          <div className={styles["form-group"]}>
            <label htmlFor="file">Archivo:</label>
            <input
              className={styles.fileInput}
              type="file"
              id="file"
              name="file"
              accept=".pdf,.jpg"
              required
              onChange={handleFileChange}
            />
          </div>
          <div className={styles["form-group"]}>
            <button className={styles.submitButton} type="submit">Subir</button>
          </div>
        </form>
      </div>
    </>
  );
}

export default NewBill;
